import { TweenMax } from 'gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoPlayer from '@/components/UI/svg/DeltaPro/Icon/EFVideoPlayer';
import EFVideo from '@/components/UI/EFVideo';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function Comp({}: any) {
    const { useEffect, useState, useLang, useRef, useRouter, gtm } = useGlobal();
    const [isEnterA, setIsEnterA] = useState(false);
    const [isShowDesc, setIsShowDesc] = useState(false);
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);
    const { t } = useLang('delta2portablepowerstation');
    const { locale } = useRouter();
    const videoRef = useRef(null);

    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;

    const videoSourceMap: any = {
        us: 'https://www.youtube.com/embed/_YQbsiPE8to',
        cn: {
            SD: 'https://videos.ecoflow.com/72a93ed2912944e394c00c987ec02d51/eca86cd8599740649e24537d42a8e4f2-1fea741c33cd80836608e25bcdde5b24-fd.mp4',
            HD: 'https://videos.ecoflow.com/72a93ed2912944e394c00c987ec02d51/eca86cd8599740649e24537d42a8e4f2-530f22b100209d9680edc68de768d511-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/4827a210-1831b1bcf81-0004-9c91-e6d-40030.mp4',
        },
        kr: 'https://www.youtube.com/embed/j2M-lCE7GlM',
        cis: 'https://www.youtube.com/embed/kvOQkL1kx7M',
    };

    const replayVideo = () => videoRef.current?.play();

    // 动画--放大字体
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.animationA',
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '50%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenA1 = TweenMax.fromTo(
            '.animationA .msg-box',
            0.4,
            {
                fontSize: ['jp', 'kr', 'es'].includes(locale) ? 20 : 30,
                opacity: 1,
                ease: 'none',
            },
            {
                opacity: 0,
                fontSize: 200,
                ease: 'none',
            },
        );
        sceneA1.setTween(tweenA1);

        sceneA1.on('enter', () => {
            setIsEnterA(true);
            setIsShowDesc(false);
            if (videoRef.current) {
                videoRef.current.currentTime = 10;
                replayVideo();
            }
        });
        document.addEventListener('touchstart', replayVideo, false);
        controllerDelta2?.addScene(sceneA1);
    }, []);

    // 动画--隐藏字体
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.animationA',
            offset: layoutH * 0.5, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '100%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', (self: any) => {
            setIsShowDesc(true);
        });

        controllerDelta2?.addScene(sceneA1);
        return () => {
            document.removeEventListener('touchstart', replayVideo, false);
        };
    }, []);

    const playerVideo = (position: any) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow DELTA 2 - Not Just a Battery',
            position,
            __btn_id1: css.animationA,
            __btn_id2: t('delta2.aniA_video_btn'),
        });
        setShowEFVideoModal(true);
    };

    return (
        <div className={`${css.animationA} animationA GtmModuleData-section`} data-section-id={css.animationA} data-section-title={t('delta2.title2')}>
            <div className={`sticky-box ${isEnterA ? 'isEnterA' : ''}`}>
                <EFVideo className="video" ref={videoRef} sources={['/video/delta2-h5/introvideo.webm', '/video/delta2-h5/introvideo.mp4']} />
                <div className="msg-box">
                    <div className="msg-title fontenter">{t('delta2.title2')}</div>
                </div>
                <div className={`msg-box2 ${isShowDesc ? 'show-desc' : ''}`}>
                    <div className="text-content">
                        <div className="w-text">{t('delta2.aniA_msg_desc')}</div>
                        <div className="watch-video-btn GtmModuleData-btn-text" onClick={() => playerVideo(t('delta2.title2'))}>
                            {t('delta2.aniA_video_btn')}
                            <EFVideoPlayer className="icon" />
                        </div>
                    </div>
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
